import React, { lazy } from 'react';
import { ShoppingBagIcon, LinkIcon, DownloadIcon, FlowerIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const APP_IMG = 'https://cdn.magicpatterns.com/uploads/erQjqjpTF7dwMEu8oFtrNg/heylloyd-image-1785289119088.png';
const steps = [{
  icon: ShoppingBagIcon,
  title: 'Compras tu acceso hoy',
  desc: 'Un solo pago, seguro y sin suscripciones ocultas.'
}, {
  icon: LinkIcon,
  title: 'Recibes tu link personalizado al instante',
  desc: 'Llega directo a tu correo, sin esperas.'
}, {
  icon: DownloadIcon,
  title: 'Lo instalas en tu celular en 1 minuto',
  desc: 'Sin App Store, sin pasos complicados.'
}, {
  icon: FlowerIcon,
  title: 'Comienzas tu Día 1 hoy mismo',
  desc: 'Tu transformación empieza en cuanto abres la app.'
}];
export function HowItWorksSection() {
  return <section className="w-full bg-crema py-20 sm:py-28" data-id="element-104" data-mp="1maw047s84p97">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-105" data-mp="1i6o8a1qgyt6r">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-106" data-mp="wamrhc5hr8hb">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-107" data-mp="wad2nrw6n7d7">
            Comenzar es más simple de lo que crees
          </h2>
          <p className="mt-4 text-lg text-tinta/70" data-id="element-108" data-mp="15b2u6jeeubl4">
            Cuatro pasos y en minutos estás dentro, cuidándote.
          </p>
        </Reveal>

        <Reveal className="mx-auto mt-10 max-w-xs sm:max-w-sm" data-id="element-109" data-mp="1a8beoqn16rpj">
          <div className="overflow-hidden rounded-3xl bg-rosa-light/20 shadow-xl shadow-rosa/15 ring-1 ring-white/70" data-id="element-110" data-mp="dl6j62nkebqc">
            <img src={APP_IMG} alt="Pantallas de la mini app Cambio Hormonal con el programa diario y el inicio de la transformación" className="h-full w-full object-cover" loading="lazy" data-id="element-111" data-mp="hm9y8mxsg3qi" />
          </div>
        </Reveal>

        <ol className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-112" data-mp="3q10moqj296q2">
          {steps.map((s, i) => <Reveal as="li" key={s.title} delay={i * 0.1} data-id="element-113" data-mp="3uz21gz9gejvq" data-mpi={i}>
              <div className="relative flex h-full flex-col rounded-3xl bg-white p-7 shadow-sm" data-id="element-114" data-mp="125d0oo8874gc">
                <span className="font-serif text-5xl font-semibold text-nude" aria-hidden="true" data-id="element-115" data-mp="x7l77prxnaa1">
                  0{i + 1}
                </span>
                <span className="mt-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-rosa/15 text-rosa-dark" data-id="element-116" data-mp="16wmnzi6axvp2">
                  <s.icon className="h-6 w-6" strokeWidth={1.6} data-id="element-117" data-mp="j83hn86tbszm" />
                </span>
                <h3 className="mt-4 font-serif text-xl font-semibold leading-snug text-tinta" data-id="element-118" data-mp="e990sbseoei5">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-tinta/70" data-id="element-119" data-mp="s5vzok3x5eqp">{s.desc}</p>
              </div>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}